import React from "react";
import { Route, Switch } from "react-router";
import NotFound from "./NotFound";

import {
  AccountOpeningFeeLoadable,
  DetailsFromKYCLoadable,
  LinkBankAccountLoadable,
  PLMAQuestionLoadable,
} from "./LoadableComponents";
import StageSelection from "./StageSelection";
import APIRequests from "../Pages/APIRequests/APIRequests";
import ApplicationDiscarded from "../Pages/ApplicationDiscarded/ApplicationDiscarded";

export default function Routes() {
  return (
    <>
      <Switch>
        <Route exact path="/api" component={APIRequests} />
        <Route exact path="/discarded" component={ApplicationDiscarded} />
        <Route path="/" component={StageSelection} />
        <Route exact path="/product" component={AccountOpeningFeeLoadable} />
        <Route exact path="/details" component={DetailsFromKYCLoadable} />
        <Route exact path="/new-profile" component={PLMAQuestionLoadable} />
        <Route
          exact
          path="/link-bank-account"
          component={LinkBankAccountLoadable}
        />
        <Route exact path="*" component={NotFound} />
      </Switch>
    </>
  );
}
